import { useState } from "react";
import { Hero } from "../components/home/Hero";
import { Featured } from "../components/home/Featured";
import { Story } from "../components/home/Story";
import { Lookbook } from "../components/home/Lookbook";
import { Newsletter } from "../components/home/Newsletter";
import { EditorialMarquee } from "../components/Marquee";
import { QuickView } from "../components/QuickView";

export default function Home() {
  const [quickView, setQuickView] = useState(null);
  return (
    <>
      <Hero />
      <EditorialMarquee />
      <Featured onQuickView={setQuickView} />
      <Story />
      <Lookbook />
      <EditorialMarquee dark items={["Limited Editions — Numbered Drops", "Complimentary Shipping Over $75", "The Centennial — Out Now"]} />
      <Newsletter />
      <QuickView product={quickView} onClose={() => setQuickView(null)} />
    </>
  );
}
